import { store } from '../../../../../../../store';
export const getCurrentEvent = (type, groupId) => {
  const channelsFromEpg = store.getState().Player.EpgChannels?.data;
  if (type === 'P' || type === 'S') return;
  const currentTime = Date.now() / 1000;

  const channelFromEpg = channelsFromEpg?.find(
    item => item?.group_id === groupId,
  );

  const currentEvent = channelFromEpg?.events?.find(
    e => e.unix_begin < currentTime && e.unix_end > currentTime,
  );

  return currentEvent;
};
